// intake-domain-redirect.js
// Safety net: any link pointing at peptrally.com/get-started (regardless of subdomain,
// e.g. a stray "www.intake." typo from a manual edit) gets corrected to the canonical
// intake.peptrally.com host before navigating. Query string (peptide=, fresh=1, etc.) is
// preserved as-is.
(function () {
  var CORRECT_HOST = 'intake.peptrally.com';
  var PATTERN = /^https?:\/\/(?:[a-z0-9-]+\.)*peptrally\.com\/get-started(\?.*)?$/i;

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      var match = href.match(PATTERN);
      if (!match) return;
      if (href.indexOf('://' + CORRECT_HOST + '/') !== -1) return;
      event.preventDefault();
      var query = match[1] || '';
      window.location.href = 'https://' + CORRECT_HOST + '/get-started' + query;
    },
    true
  );
})();
